<div class="grid">
  <app-kpi-card
    class="kpi-card"
    [value]="data[0]?.value"
    [label]="'charts.labels.' + data[0]?.label | translate"
    icon="navigation-2-outline"
    [change]="data[0]?.delta_pct"
    [loading]="isLoading"
  ></app-kpi-card>
  <app-kpi-card
    class="kpi-card"
    [value]="data[1]?.value"
    [label]="'charts.labels.' + data[1]?.label | translate"
    icon="clock-outline"
    [change]="data[1]?.delta_pct"
    [loading]="isLoading"
  ></app-kpi-card>
  <app-kpi-card
    class="kpi-card"
    [value]="data[2]?.value"
    [label]="'charts.labels.' + data[2]?.label | translate"
    icon="done-all-outline"
    unit="%"
    [change]="data[2]?.delta_pct"
    [loading]="isLoading"
  ></app-kpi-card>
  <app-kpi-card
    class="kpi-card"
    [value]="data[3]?.value"
    [label]="'charts.labels.' + data[3]?.label | translate"
    icon="message-square-outline"
    [change]="data[3]?.delta_pct"
    [loading]="isLoading"
  ></app-kpi-card>
  <app-kpi-card
    class="kpi-card"
    [value]="data[4]?.value"
    [label]="'charts.labels.' + data[4]?.label | translate"
    icon="book-outline"
    [change]="data[4]?.delta_pct"
    [loading]="isLoading"
  ></app-kpi-card>
  <app-kpi-card
    class="kpi-card"
    [value]="data[5]?.value"
    [label]="'charts.labels.' + data[5]?.label | translate"
    icon="star-outline"
    [change]="data[5]?.delta_pct"
    [loading]="isLoading"
  ></app-kpi-card>
  <app-kpi-card
    class="kpi-card"
    [value]="data[6]?.value"
    [label]="'charts.labels.' + data[6]?.label | translate"
    icon="close-square-outline"
    [change]="data[6]?.delta_pct"
    [loading]="isLoading"
  ></app-kpi-card>
  <app-kpi-card
    class="kpi-card"
    [value]="data[7]?.value"
    [label]="'charts.labels.' + data[7]?.label | translate"
    icon="smiling-face-outline"
    [change]="data[7]?.delta_pct"
    [loading]="isLoading"
    unit="%"
  ></app-kpi-card>
</div>
